import { render, staticRenderFns } from "./PersistAlertaCargaView.vue?vue&type=template&id=df1f3886&"
import script from "./PersistAlertaCargaView.vue?vue&type=script&lang=ts&"
export * from "./PersistAlertaCargaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports